import { useContext } from 'react';
import { FieldConfirmMode } from '../../FieldControlled/common.js';
import FormFieldPropertiesContext from '../../Form/FormFieldPropertiesContext.js';

function useFormConfirmMode(confirmMode) {
    const props = useContext(FormFieldPropertiesContext);
    if (confirmMode !== undefined) {
        return confirmMode;
    }
    if (props.confirmMode !== undefined) {
        return props.confirmMode;
    }
    return FieldConfirmMode.ON_BLUR;
}

export { useFormConfirmMode as default };
